// -----------------------------------------------------------------------------
// useVoiceAssistant.js
// Wrapper hook for accessing the VoiceContext.
// -----------------------------------------------------------------------------

import { useVoiceAssistant as useVoiceAssistantHook } from "./VoiceContext.jsx";


// Default export — required for components importing:
//   import useVoiceAssistant from "./useVoiceAssistant";
export default function useVoiceAssistant() {
  return useVoiceAssistantHook();
}
